import { createContext, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getProfile } from '../api/admin';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      getProfile()
        .then(res => {
          setUser(res.admin);
          setPermissions(res.permissions);
          setLoading(false);
        })
        .catch(() => {
          localStorage.removeItem('admin_token');
          setLoading(false);
          navigate('/login');
        });
    } else {
      setLoading(false);
    }
  }, [navigate]);

  const login = (token, admin) => {
    localStorage.setItem('admin_token', token);
    setUser(admin);
    // 重新获取权限
    getProfile().then(res => {
      setPermissions(res.permissions);
    });
  };

  const logout = () => {
    localStorage.removeItem('admin_token');
    setUser(null);
    setPermissions([]);
    navigate('/login');
  };

  const hasPermission = (code) => {
    if (!user) return false;
    if (user.is_super === 1) return true;
    return permissions.includes(code);
  };

  return (
    <AuthContext.Provider value={{ user, permissions, loading, login, logout, hasPermission }}>
      {children}
    </AuthContext.Provider>
  );
};